import React from 'react';
import { Grid, Card, Icon, Image, Button } from 'semantic-ui-react';
import { withRouter } from 'react-router-dom';
import { S3_BASE_URL } from '../../config/API';

const VM = ({ vmId, name, city, state, street, image_id, history }) => (
  <Grid.Column width={4} style={{ marginBottom: '20px' }}>
    <Card>
      {image_id && (
        <Image style={{ height: '60px', width: '120px' }} src={`${S3_BASE_URL}/${image_id}`} />
      )}
      <Card.Content>
        <Card.Header>{name}</Card.Header>
        <Card.Meta>
          <span className="date">VM ID : {vmId}</span>
        </Card.Meta>
        <Card.Description>
          {city}, {state}
        </Card.Description>
      </Card.Content>
      <Card.Content extra>
        <Icon name="location arrow" />
        {street}
      </Card.Content>
      <Card.Content extra>
        <div className="ui two buttons">
          <Button
            basic
            color="blue"
            onClick={() => history.push(`/vendingmachines/${vmId}/details`)}
          >
            Inventory
          </Button>
          <Button
            basic
            color="black"
            onClick={() => history.push(`/vendingmachines/${vmId}/reporting`)}
          >
            Sales
          </Button>
        </div>
      </Card.Content>
    </Card>
  </Grid.Column>
);

export default withRouter(VM);



// WEBPACK FOOTER //
// ./src/Modules/Sales&Inventory/VM.jsx